<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8091 20.6759C11.5741 20.9099 11.1938 20.9089 10.96 20.6736L6.03157 15.7124C5.79488 15.4741 5.79983 15.088 6.04255 14.8559L7.68941 13.281C7.92568 13.0551 8.29936 13.0599 8.52976 13.2918L10.9578 15.7359C11.1924 15.9721 11.5745 15.9721 11.8091 15.7359L20.2606 7.2283C20.4953 6.99211 20.8773 6.99211 21.112 7.22829L22.7783 8.90565C23.0116 9.14053 23.0106 9.52001 22.776 9.75364L11.8091 20.6759Z"
      fill="currentColor"
    />
  </svg>
</template>
